import { useState, useEffect } from "react"

type Props = {
  content: string
  deps?: any[]
  className?: string
}

export async function markdownToHtml(markdown) {
  const { remark } = await import("remark")
  const html = (await import("remark-html")).default
  // const prism = (await import("remark-prism")).default

  const result = await remark().use(html).process(markdown)
  return result.toString()
}

const MarkdownBlock = ({
  content,
  deps = [],
  className = "sl-prose sl-text-left sl-break-words"
}: Props) => {
  const [htmlContent, setHtmlContent] = useState("")

  const handleFormatContent = async () => {
    setHtmlContent(await markdownToHtml(content))
  }

  useEffect(() => {
    handleFormatContent()
  }, deps)

  return (
    <div
      className={className}
      dangerouslySetInnerHTML={{ __html: htmlContent }}
    />
  )
}

export default MarkdownBlock
